import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { exportBookingsAsXls } from '../lib/bookings';

export const useExportBookingsAsXls = (onSuccess?: () => void) => {
  const { t } = useTranslation(['bookings', 'common']);

  return useMutation({
    mutationFn: ({ from, to }: { from: Date; to: Date }) =>
      exportBookingsAsXls(from, to),
    onSuccess: () => {
      toast.success(
        t('bookings:common.exportBookingsAsXlsDialog.successMessage'),
      );
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      const errorMessage = error?.response?.data?.message;

      toast.error(errorMessage || t('common:errorMessages.somethingWentWrong'));
    },
  });
};
